var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C868"
    },
    d: "M511.879,475.685l-40.224-221.611c-0.401-2.212-1.773-4.128-3.739-5.221l-101.242-56.31 c-1.314-0.732-2.787-1.023-4.234-0.911l18.419,237.608l-0.617,0.276l121.164,54.357c0.986,0.441,2.034,0.659,3.077,0.659 c1.651,0,3.287-0.543,4.632-1.596C511.313,481.22,512.376,478.428,511.879,475.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C868"
    },
    d: "M256,246.375l-103.545-53.931c-1.241-0.647-2.617-0.911-3.972-0.82 c0.359-0.022,0.72-0.02,1.078,0.008l-18.419,237.608l121.781,54.634c0.983,0.44,2.032,0.659,3.077,0.659l0,0V246.375z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CE166"
    },
    d: "M149.56,191.633c-1.447-0.112-2.92,0.179-4.234,0.91l-101.243,56.31 c-1.966,1.093-3.338,3.008-3.739,5.221L0.121,475.685c-0.498,2.742,0.566,5.534,2.763,7.252c1.347,1.053,2.982,1.596,4.632,1.596 c1.043,0,2.092-0.217,3.077-0.659l120.504-54.061L149.56,191.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CE166"
    },
    d: "M362.439,191.628c-0.996,0.077-1.981,0.342-2.894,0.818L256,246.376v238.158c0,0,0,0,0.001,0 c1.045,0,2.095-0.218,3.077-0.659l121.781-54.634L362.439,191.628z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDB56"
    },
    points: "28.154,321.233 19.983,366.252 140.977,302.346 143.786,266.107 144.252,260.097 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8EEFC"
    },
    d: "M142.066,288.294l-1.089,14.052L19.983,366.252L0.121,475.685c-0.498,2.742,0.566,5.534,2.763,7.252 c1.347,1.053,2.982,1.596,4.632,1.596c1.043,0,2.092-0.217,3.077-0.659l120.504-54.061L142.066,288.294L142.066,288.294z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBB24"
    },
    points: "256.03,276.08 144.252,260.097 140.977,302.346 256,477.025 256,413.507 187.363,305.429  256.03,313.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBB24"
    },
    points: "459.946,244.421 411.311,217.37 365.269,228.128 365.845,235.564 368.119,264.898  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDB56"
    },
    points: "372.202,317.576 367.842,261.327 367.842,261.327 365.269,228.128 256.03,276.08  256.03,313.642 327.386,282.612 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBB24"
    },
    d: "M511.879,475.685l-10.103-55.666L368.119,264.898l4.084,52.678l137.07,165.221 C511.357,481.07,512.364,478.358,511.879,475.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4A4A"
    },
    d: "M256.481,27.465c-57.963,0-105.12,47.118-105.12,105.034c0,35.826,17.009,74.29,50.556,114.322 c24.639,29.403,48.943,48.314,49.966,49.105c1.354,1.047,2.976,1.57,4.599,1.57c1.622,0,3.245-0.523,4.599-1.57 c1.022-0.791,25.327-19.702,49.966-49.105c33.547-40.032,50.556-78.495,50.556-114.322 C361.601,74.583,314.444,27.465,256.481,27.465z M295.411,132.498c0,21.482-17.43,38.898-38.93,38.898 c-21.5,0-38.93-17.415-38.93-38.898s17.43-38.898,38.93-38.898C277.981,93.6,295.411,111.016,295.411,132.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7343F"
    },
    d: "M256.481,27.465c-4.594,0-9.119,0.298-13.559,0.872c51.583,6.667,91.562,50.836,91.562,104.162 c0,35.826-17.009,74.29-50.556,114.322c-15.845,18.908-31.54,33.467-41.005,41.669c5.254,4.552,8.596,7.154,8.96,7.436 c1.354,1.047,2.976,1.57,4.599,1.57c1.622,0,3.245-0.523,4.599-1.57c1.022-0.791,25.327-19.702,49.966-49.105 c33.547-40.032,50.556-78.495,50.556-114.322C361.601,74.583,314.444,27.465,256.481,27.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDB56"
    },
    d: "M259.078,483.874l45.285-20.316L256,413.507v71.026c0,0,0,0,0.001,0 C257.046,484.533,258.095,484.316,259.078,483.874z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1EA4E9"
    },
    d: "M471.654,254.074c-0.401-2.212-1.773-4.128-3.739-5.221l-7.97-4.433l-91.827,20.477l0,0 l133.656,155.121L471.654,254.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1EA4E9"
    },
    d: "M255.999,484.533C256,484.533,256,484.533,255.999,484.533v-7.508L140.977,302.346l-9.837,126.895 l121.781,54.634C253.904,484.316,254.953,484.533,255.999,484.533z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.8ffe5ab169d78b8ed161a71a3beee73e.svg";
export { ForwardRef as ReactComponent };